import React from 'react';
import { H2, H4 } from '@wco/toolkit';
import styled from 'styled-components';

type PageHeaderType = {
  headerText: string | undefined;
};

const StyledH4 = styled(H4)`
  color: #424242;
`;

export default function PageHeader(props: PageHeaderType) {
  return (
    <>
      <H2>Find medarbejdere</H2>
      <StyledH4>{props.headerText}</StyledH4>
    </>
  );
}
